import {
    app,
    ojs,
    Runner,
    registerNodeDisposalCallback,
    removeNodeModifications,
    payload,
} from "modular-openscriptjs";
import {
    closeDropdown,
    dom,
    Filter,
    FSEventEmitter,
    IdGenerator,
    openDropdown,
    Pipeline,
    Requester,
    tool,
} from "./fotastart";
import {
    closeModal,
    closeAllModals,
    deepEqual,
    disposeBootstrapTree,
    fireEvent,
    formatDuration,
    getModalData,
    hideCanvas,
    hideModal,
    inform,
    getStatusClass,
    openCustomerSupport,
    openModal,
    openCloseableModal,
    pageInfo,
    redirect,
    saveUser,
    scrollToTop,
    sendEvent,
    showActionButton,
    empty,
    getStore,
    deleteFromStorage,
    refreshOtpVerifiedAt,
    unfreezeBodyWhenNoModalOrOffcanvas,
} from "./helpers";
import AppOffCanvas from "./components/Offcanvas/AppOffCanvas";
import { dc, uc, pc, gc } from "./ojs.contexts";
import { $e } from "./ojs.events";
import {
    sideNavItems,
    offcanvasNavItems,
    bottomNavItems,
} from "./declarations";

const router = app("router");
const broker = app("broker");
const route = router;
const EchoEventListener = app("EchoEventListener");

pc.sideItems.value = sideNavItems;
pc.offCanvasItems.value = offcanvasNavItems;
pc.bottomItems.value = bottomNavItems;

tool.makeGlobal(
    [app, "app"],
    [fireEvent, "fireEvent"],
    [sendEvent, "sendEvent"],
    [showActionButton, "showActionButton"],
    [redirect, "redirect"],
    [inform, "inform"],
    [scrollToTop, "scrollToTop"],
    [hideCanvas, "hideCanvas"],
    [hideModal, "hideModal"],
    [pageInfo, "pageInfo"],
    [EchoEventListener, "EchoEventListener"],
    [formatDuration, "formatDuration"],
    [deepEqual, "deepEqual"],
    [tool, "tool"],
    [dom, "dom"],
    [IdGenerator, "IdGenerator"],
    [Requester, "Requester"],
    [Pipeline, "Pipeline"],
    [Filter, "Filter"],
    [FSEventEmitter, "FSEventEmitter"],
    [route, "route"],
    [router, "router"],
    [gc, "gc"],
    [uc, "uc"],
    [pc, "pc"],
    [dc, "dc"],
    [broker, "broker"],
);

window.app = app;
window.router = router;
window.route = route;
window.openCustomerSupport = openCustomerSupport;
window.openModal = openModal;
window.openCloseableModal = openCloseableModal;
window.closeModal = closeModal;
window.closeAllModals = closeAllModals;
window.getModalData = getModalData;
window.openDropdown = openDropdown;
window.closeDropdown = closeDropdown;
window.EchoEventListener = EchoEventListener;
window.getStatusClass = getStatusClass;

registerNodeDisposalCallback(
    /**
     * @param {Node} node
     */
    (node) => {
        disposeBootstrapTree(node);
        removeNodeModifications(node);
    },
);

const h = app("h");
ojs(AppOffCanvas);
h.AppOffCanvas({ parent: dom.id("canvas-root") });

import { Preferences } from "@capacitor/preferences";
import { api } from "./declarations";
import './firebase';

const initAuth = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get("token");

    if (token) {
        await Preferences.set({ key: "auth_token", value: token });
        const url = new URL(window.location);
        url.searchParams.delete("token");
        window.history.replaceState({}, document.title, url);
    } else {
        const { value } = await Preferences.get({ key: "auth_token" });
        token = value;
    }

    if (token) {
        api.token = token;
    }
};

const initUser = async () => {
    const user = await getStore("user");
    if (user) {
        gc.user.value = user;
        gc.auth.value = true;
    }

    // Scope the OTP grace period to the signed-in user so a previous
    // account's verification can never be reused by a different one.
    await refreshOtpVerifiedAt(user?.id);
};

const initStorage = async () => {
    const companies = await getStore("delivery_companies");
    if (companies) {
        dc.deliveryCompanies.value = companies;
        window.deliveryCompanies = companies;
    }

    const currentCompany = await getStore("current_delivery_company");

    if (currentCompany) {
        window.currentCompany = currentCompany;
        window.currentDeliveryCompany = currentCompany;
    }
};

const verifySession = async () => {
    if (!api.token) return;

    const res = await api.get("/users/current", {}, { silent: true });

    if (res && !empty(res.data.user)) {
        gc.user.value = res.data.user;
        gc.auth.value = true;
        await saveUser(res.data.user);
        await refreshOtpVerifiedAt(res.data.user.id);
    } else {
        await deleteFromStorage("auth_token");
        await deleteFromStorage("user");
        await deleteFromStorage("delivery_companies");
        await deleteFromStorage("current_delivery_company");

        gc.user.value = {};
        gc.auth.value = false;
        window.otpVerifiedAt = 0;
        api.token = null;

        broker.broadcast($e.system.needs.configReload);
    }
};

app("broker").on("ojs:routeChanged", async () => {
    unfreezeBodyWhenNoModalOrOffcanvas();
});

const bootSystem = async () => {
    try {
        await initAuth();
        await initUser();
        await initStorage();
        await verifySession();
    } catch (err) {
        console.error(err);
    }

    broker.broadcast($e.system.booted);
    router.listen();
};

bootSystem();
